import { render, staticRenderFns } from "./ProductListingsLayout.vue?vue&type=template&id=7ba5b650&lang=pug&"
import script from "./ProductListingsLayout.vue?vue&type=script&lang=js&"
export * from "./ProductListingsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports